import {createRouter, createWebHashHistory, createWebHistory, createMemoryHistory} from 'vue-router'
import Home from '../views/Home.vue'
// import Model from '../views/00_Model.vue'
//import Help from "../views/Help";

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },

    {
        path: '/Hergang',
        component: () => import(/* webpackChunkName: "infobox" */ '../views/010_Hergang.vue')
    },

    {
        path: '/Gau',
        component: () => import(/* webpackChunkName: "infoboxcomparison" */ '../views/020_Gau.vue')
    },

    {
        path: '/Strahlung',
        component: () => import(/* webpackChunkName: "infoboxvideo" */ '../views/030_Strahlung.vue')
    },

    {
        path: '/Betonhuelle',
        component: () => import(/* webpackChunkName: "animation" */ '../views/040_Beton.vue')
    },

    {
        path: '/NSC',
        component: () => import(/* webpackChunkName: "audio" */ '../views/050_NSC.vue')
    },

    {
        path: '/Drohne',
        component: () => import(/* webpackChunkName: "billboard" */ '../views/060_Drohne.vue'),
        // meta: {
        //     title: 'Billboard Mode'
        // }
    },
    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "hotspots" */ '../views/070_Credits.vue'),
        // meta: {
        //     title: 'Hotspots'
        // }
    },

];

function getHistory()
{
    if (process.env.VUE_APP_ROUTER_MODE === 'hash')
    {
        return createWebHashHistory();
    }

    if (process.env.VUE_APP_ROUTER_MODE === 'history')
    {
        return createWebHistory();
    }

    return createMemoryHistory();
}

const router = createRouter({
    history: getHistory(),
    base: process.env.BASE_URL,
    routes
});

export default router
